import { useContext } from "react";
import { Node } from "../../types/Node";
import { ConfiguracoesContext } from "../../contexts/Configuracoes/ConfiguracoesContext";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { PERMISSOES } from "../../services/Consts";

const useNodes = () => {
  const { configuracoes, loading } = useContext(ConfiguracoesContext);
  const { empresa } = useContext(EmpresaContext);
  const { permissoesUsuario, customizadas } = useContext(AuthContext);

  // Usuarios com acesso a mensageria (remover quando liberar pra todos)
  const MENSAGERIA_USUARIOS_LIBERADOS = ['lerinV3', 'Amifluffy'];
  const mensageriaLiberada = MENSAGERIA_USUARIOS_LIBERADOS.includes(empresa?.usuario || '');

  const nodes: Node[] = [
  {
    id: "suaempresa",
    name: "Sua Empresa",
    children: [
      {
        id: "informacoesdamarca",
        name: "Informações da Marca",
      },
      {
        id: "endereco",
        name: "Endereço",
      },
    ],
  },
  {
    id: "configureseucatalogo",
    name: "Configure seu Catálogo",
    children: [
      {
        id: "pedido",
        name: "Pedido",
      },
      {
        id: "politicadeprivacidade",
        name: "Política de Privacidade",
      },
      {
        id: "politicadetrocaedevolucao",
        name: "Política de Troca e Devolução",
      },
      {
        id: "politicadefrete",
        name: "Política de Frete",
      },
      {
        id: "compartilhamento",
        name: "Compartilhamento",
      },
      {
        id: "visual",
        name: "Visual",
      },
    ],
  },
  {
    id: "promocoes",
    name: "Promoções",
    children: [
      {
        id: "cupons",
        name: "Cupons",
      },
      {
        id: "brindes",
        name: "Brindes",
      },
      {
        id: "fretegratis",
        name: "Frete Grátis",
      },
    ],
  },
  {
    id: "entregaeretirada",
    name: "Entrega e Retirada",
    children: [
      {
        id: "correios",
        name: "Correios",
      },
      {
        id: "melhorenvio",
        name: "Melhor Envio",
      },
      {
        id: "entregalocal",
        name: "Entrega Local",
      },
      {
        id: "entregaespecial",
        name: "Entrega Especial",
      },
      {
        id: "retiradanolocal",
        name: "Retirada no Local",
      },
    ],
  },
  {
    id: "pagamento",
    name: "Pagamento",
    children: [
      // Só mostra Stone se o cliente realmente tiver ele ativo (toggle ligado)
      ...(!loading && configuracoes?.pagarmeAtivo ? [{
        id: "pagarme",
        name: "Stone (API)",
      }] : []),
      {
        id: "pagarmehub",
        name: "Stone",
      },
      {
        id: "pagbank",
        name: "PagBank",
      },
      {
        id: "mercadopago",
        name: "Mercado Pago",
      },
      // {
      //   id: "pagamentoonline",
      //   name: "Pagamento Online",
      // },
      {
        id: "pagamentoacombinar",
        name: "Pagamento a Combinar",
      },
    ],
  },
  ...(mensageriaLiberada ? [{
    id: "mensageria",
    name: "Comunicação",
    children: [
      {
        id: "whatsapp",
        name: "WhatsApp",
      },
    ],
  }] : []),
  {
    id: "integracoes",
    name: "Integrações",
    children: [
      {
        id: "chaveintegracao",
        name: "Chave de API",
      },
      {
        id: "integracaodobling",
        name: "Bling",
      },
      {
        id: "integracaodatiny",
        name: "Olist",
      },
      {
        id: "dropshipping",
        name: "Dropshipping",
      },
/*       {
        id: "verificacoesdedominio",
        name: "Verificações de Domínio",
      }, */
      {
        id: "facebookpixel",
        name: "Meta",
      },
      {
        id: "pinterest",
        name: "Pinterest",
      },
      {
        id: "google",
        name: "Google",
      },
      {
        id: "recaptcha",
        name: "reCAPTCHA",
      },
    ],
  },
];

  // Eixo A (permissões por usuário): cada seção-raiz tem uma pílula de config.
  const SECAO_PERMISSAO: { [id: string]: number } = {
    suaempresa: PERMISSOES.CONFIG_SUA_EMPRESA,
    configureseucatalogo: PERMISSOES.CONFIG_CATALOGO,
    promocoes: PERMISSOES.CONFIG_PROMOCOES,
    entregaeretirada: PERMISSOES.CONFIG_ENTREGA_RETIRADA,
    pagamento: PERMISSOES.CONFIG_PAGAMENTO,
    integracoes: PERMISSOES.CONFIG_INTEGRACOES,
  };
  // Customizado sem a pílula da seção vê a seção em modo leitura (bloqueado). Não-customizado vê/edita tudo
  // (regra 1). Seções sem pílula (ex.: Comunicação) nunca bloqueiam.
  const nodesComBloqueio = nodes.map((n) => ({
    ...n,
    bloqueado:
      customizadas && !!SECAO_PERMISSAO[n.id] && !permissoesUsuario?.includes(SECAO_PERMISSAO[n.id]),
  }));

  return nodesComBloqueio;
};

export default useNodes;
